<template>
    <div>

        <!-- mensajes de confirmacion -->
        <mensajeSistema></mensajeSistema>

        <!-- Carga el compononte para activar modal de  ver calendario -->
        <component :is="componenteCalendario" :modalCalen="estadoModalCalen" @close="estadoModalCalen = false"></component>
        <!-- <Calendario></Calendario> -->

        <!-- Calendario de activadades de la seccion -->
        <component :is="tipoComponente" :modalActividad="estadoModal" @close="estadoModal = false"
                   :datosClase="itemClaseSeccion" :eventoActividad="valorEvento">
        </component>

        <!-- Componente de Asistencia de clase programada -->
        <component :is="componenteAsistencia" :modalAsistencia="estadoModalAsistencia" @close="estadoModalAsistencia = false"
                   :datosProgDocente="parametroAsistencia">
        </component>

        <!-- Componente de selecionar clase ck1 o colegio  -->
        <component :is="componenteSelecClaseEC" :modalSelecClaseEC="estadoModalSelecClaseEC" @close="estadoModalSelecClaseEC = false"
                   :datosSelecClaseEC="parametroSelecClaseEC" @visorec="visualizarClase" @addselecclaseec="addItem"
                   :actualizarConsultaEC="estadoConsultaEC">
        </component>


        <!-- Componente de modal programar clase -->
        <component :is="componenteProgClase" :modalProgClase="estadoModalProgClase" @close="estadoModalProgClase = false"
                   :datosProgClase="parametroProgClase"
                   :actualizarConsultaProgClase="estadoConsultaProgClase" @cargarmain="cargarMain()">
        </component>


        <!-- MODAL VISOR DE CONTENIDOS-->
        <v-dialog v-model="visor" scrollable max-width="80%">
            <v-card>
                <v-card-title class="btn_otro">
                    <v-row class="d-flex justify-space-between py-0">
                        Contenido
                        <v-btn fab dark x-small class="btn_style3" @click="cerrarVisor"><v-icon dark>fa-times</v-icon></v-btn>
                    </v-row>
                </v-card-title>

                <v-divider></v-divider>


                <v-card-text class="text-center">
                        <component :is="tipoVisor"  :diapositivas="api_list_contenidos"></component>
                        <!-- <ModalVisorCk1 :diapositivas="api_list_contenidos" ></ModalVisorCk1> -->
                </v-card-text>

            </v-card>
        </v-dialog>




        <!-- boton crear -->
        <v-row>
            <v-col class="d-flex justify-end pt-0">
                <v-col cols="auto" class="pr-0">
                    <v-btn class="btn_block_style2" dark  v-if="componenteEvento.agregar_submodulo" @click="asociarClaseEc">PROGRAMAR CLASE</v-btn>
                </v-col>

                <v-col cols="auto" class="pr-0">
                    <v-btn class="btn_block_style2" dark  v-if="componenteEvento.agregar_submodulo" to="/gestionContenidoColegio">gestión de contenidos</v-btn>
                </v-col>

                <v-col cols="auto" class="pr-0">
                    <v-btn class="btn_block_style2" dark  v-if="componenteEvento.visualizar_submodulo" @click="verCalendario">VER CALENDARIO</v-btn>
                </v-col>

                <v-col cols="auto" class="pr-0">
                    <v-btn class="btn_block_style2" dark  v-if="componenteEvento.visualizar_submodulo" @click="verActividades">ACTIVIDADES</v-btn>
                </v-col>
            </v-col>
        </v-row>
        <!-- fin de boton -->




        <!-- /////////////////////////////////////////////////////
            //    PANTALLA PRINCIPAL DE PROGRAMACION DOCENTE   //
        ///////////////////////////////////////////////////////////    -->
        <v-card>
            <v-row class="mx-1">
                <v-col cols="12" sm="3" md="" class="py-0">
                    <v-autocomplete label="Nivel" v-model="filtroProgDoc.id_nivel" :items="nivelDoc" autocomplete="off"
                        item-value="id_nivel" item-text="desc_nivel" @change="eventNivelDoc">
                    </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="3" md="" class="py-0">
                    <v-autocomplete label="Grado" v-model="filtroProgDoc.id_grado" :items="gradoDocFilter" :disabled="inhabilitarGradoDoc" autocomplete="off"
                        item-value="id_grado" item-text="desc_grado" @change="eventGradoDoc">
                    </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="3" md="" class="py-0">
                    <v-autocomplete label="Área" v-model="filtroProgDoc.id_area" :items="areaDocFilter" :disabled="inhabilitarAreaDoc" autocomplete="off"
                        item-value="id_area" item-text="desc_area" @change="eventAreaDoc">
                    </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="3" md="" class="py-0">
                    <v-autocomplete label="Curso"  v-model="filtroProgDoc.id_curso" :items="cursoDocFilter" :disabled="inhabilitarCursoDoc" autocomplete="off"
                        item-value="id_curso" item-text="desc_curso">
                    </v-autocomplete>
                </v-col>
                  <!--<v-col cols="12" sm="3" md="" class="py-0">
                    <v-autocomplete :label="$t('titulo.curso')" v-model="filtroProgDoc.id_curso" :items="cursoDocFilter" :disabled="inhabilitarCursoDoc" autocomplete="off"
                        item-value="id_curso" item-text="desc_curso">
                    </v-autocomplete>
                </v-col>-->



                <v-col cols="4" md="" class="py-0">
                    <v-text-field label="Buscar" v-model="search" append-icon="fa-search" single-line hide-details ></v-text-field>
                </v-col>
            </v-row>



            <v-data-table :items="progDocente" :search="search" class="elevation-1 black--text" fixed-header>
                <template  v-slot:header>
                    <thead>
                        <tr>
                            <th class="secondary black--text" >GRADO</th>
                            <th class="secondary black--text text-uppercase" >{{$t('titulo.salon')}}</th>
                            <th class="secondary black--text">TEMA</th>
                            <th class="secondary black--text">CLASE</th>
                            <th class="secondary black--text">FECHA</th>
                            <th class="secondary black--text">HORA INICIO</th>
                            <th class="secondary black--text">HORA FIN</th>
                            <th class="secondary black--text">ESTADO</th>
                            <th class="secondary black--text px-0 mx-0"  align="center">VISUALIZAR</th>
                            <th class="secondary black--text px-0 mx-0"  align="center">EDITAR</th>
                            <th class="secondary black--text px-0 mx-0" width="90" align="center">ASIGNAR ACTIVIDAD</th>
                            <th class="secondary black--text px-0 mx-0"   width="110" align="center">ASISTENCIA DE CLASE VIRTUAL</th>
                            <th class="secondary black--text px-0 mx-0" width="90" align="center">SEGUIMIENTO</th>
                        </tr>
                    </thead>
                </template>


                <template  v-slot:body="{ items }">
                    <tbody>
                        <tr v-for="item in items" :key="item.id">
                            <td>{{ item.desc_grado }}</td>
                            <td>{{ item.nombre_seccion }}</td>
                            <td>{{ item.nombre_tema }}</td>
                            <td>{{ item.nombre_clase }}</td>

                            <td><span>{{item.fecha | filtroFecha}}</span></td>
                            <td> <span>{{item.hora_inicio | filtroFormatoHora}}</span></td>
                            <td><span>{{item.hora_fin | filtroFormatoHora}}</span></td>

                            <td>
                                <v-chip small dark class="font-weight-black" :color="item.color_estado">
                                    {{item.desc_estado}}
                                </v-chip>
                            </td>

                            <td>
                                <v-menu absolute offset-y style="max-width: 600px" >
                                    <template v-slot:activator="{ on }">

                                        <v-row justify="space-around" v-on="on">
                                            <v-avatar class="btn_ver px-0 mx-0 mt-1 white--text" size="19">
                                                <v-icon class="white--text" size="11">fa-eye</v-icon>
                                            </v-avatar>

                                            <v-avatar class="btn_virtual px-0 mx-0 mt-1 white--text" size="19">
                                                <v-icon class="white--text" size="11">fa-video</v-icon>
                                            </v-avatar>

                                            <v-avatar class="btn_eliminar px-0 mx-0 mt-1 white--text" size="19">
                                                <v-icon class="white--text" size="11">fa-play</v-icon>
                                            </v-avatar>
                                        </v-row>
                                    </template>


                                    <v-card>
                                        <v-row>

                                            <v-col class="py-0" cols="auto">
                                                <v-tooltip bottom color="#1b1b1b">
                                                    <template v-slot:activator="{ on }">

                                                        <v-col>
                                                            <v-row class="py-0">
                                                                <span style="font-size: 11px" class="font-weight-bold">VER CLASE</span>
                                                            </v-row>

                                                            <v-row class="py-0">
                                                                <v-btn v-if="componenteEvento.visualizar_submodulo" v-on="on" class="btn_ver mx-auto mb-1" fab x-small @click="visualizarClase(item.id_clase, item.tipo_contenido)">
                                                                    <v-icon>fa-eye</v-icon>
                                                                </v-btn>
                                                            </v-row>
                                                        </v-col>

                                                    </template>
                                                    <span>VER CLASE</span>
                                                </v-tooltip>
                                            </v-col>


                                            <v-col class="py-0" cols="auto">
                                                <v-tooltip bottom color="#1b1b1b" v-if="componenteEvento.visualizar_submodulo && item.clase_virtual">
                                                    <template v-slot:activator="{ on }">

                                                        <v-col>
                                                            <v-row class="py-0">
                                                                <span style="font-size: 11px" class="font-weight-bold">CLASE VIRTUAL</span>
                                                            </v-row>

                                                            <v-row class="py-0">
                                                                <v-btn v-on="on"  class="mx-auto mb-1 btn_virtual" @click="validarEnlace(item.enlace_virtual, item.hora_inicio, item.hora_fin, item.id_estado)" :disabled="item.id_estado == 3 || item.id_estado == 4 || (new Date(item.fecha).toISOString().substr(0,10) != new Date().toISOString().substr(0,10)) " fab x-small>
                                                                    <v-icon>fa-video</v-icon>
                                                                </v-btn>
                                                            </v-row>
                                                        </v-col>
                                                    </template>
                                                    <span>VER CLASE VIRTUAL</span>
                                                </v-tooltip>


                                                <v-tooltip bottom color="#1b1b1b"  v-if="!item.clase_virtual" >
                                                    <template v-slot:activator="{ on }">
                                                        <v-col>
                                                            <v-row class="py-0">
                                                                <span style="font-size: 11px" class="font-weight-bold">CLASE VIRTUAL</span>
                                                            </v-row>

                                                            <v-row class="py-0">
                                                                <v-btn v-on="on" class="mx-2 btn_deshabilitar" :disabled="item.id_estado == 3 || item.id_estado == 4" fab x-small>
                                                                    <v-icon>fa-video-slash</v-icon>
                                                                </v-btn>
                                                            </v-row>
                                                        </v-col>

                                                    </template>
                                                    <span>NO TIENE CLASE VIRTUAL</span>
                                                </v-tooltip>
                                            </v-col>


                                            <v-col class="py-0" cols="auto">

                                                <v-tooltip bottom color="#1b1b1b" v-if="componenteEvento.visualizar_submodulo && item.clase_virtual_video == 1">
                                                    <template v-slot:activator="{ on }">
                                                        <v-col>
                                                            <v-row class="py-0">
                                                                <span style=" font-size: 11px" class="font-weight-bold">VER VIDEO DE CLASE GRABADA</span>
                                                            </v-row>

                                                            <v-row class="py-0">
                                                                <v-btn v-on="on" class="mx-auto mb-1 btn_eliminar" fab x-small :href="item.clase_virtual_video_enlace" target="_blank">
                                                                    <v-icon>fa-play</v-icon>
                                                                </v-btn>
                                                            </v-row>
                                                        </v-col>
                                                    </template>
                                                    <span>VER VIDEO DE CLASE GRABADA</span>
                                                </v-tooltip>


                                                <v-tooltip bottom color="#1b1b1b">
                                                    <template v-slot:activator="{ on }" v-if="item.clase_virtual_video == 0">
                                                        <v-col>
                                                            <v-row class="py-0">
                                                                <span style=" font-size: 11px" class="font-weight-bold">VER VIDEO DE CLASE GRABADA</span>
                                                            </v-row>

                                                            <v-row class="py-0">
                                                                <v-btn v-on="on" class="mx-auto mb-1" disabled fab x-small >
                                                                    <v-icon>fa-play</v-icon>
                                                                </v-btn>
                                                            </v-row>
                                                        </v-col>
                                                    </template>
                                                    <span> NO TIENE VIDEO DE CLASE GRABADA</span>
                                                </v-tooltip>
                                            </v-col>

                                        </v-row>
                                    </v-card>

                                </v-menu>

                            </td>


                            <td>
                                <v-menu absolute offset-y style="max-width: 600px" >
                                    <template v-slot:activator="{ on }">

                                        <v-row justify="space-around" v-on="on">
                                            <v-avatar class="btn_editar px-0 mx-0 mt-1 white--text" size="19">
                                                <v-icon class="white--text" size="11">fa-pencil-alt</v-icon>
                                            </v-avatar>

                                            <v-avatar class="btn_eliminar px-0 mx-0 mt-1 white--text" size="19">
                                                <v-icon class="white--text" size="11">fa-trash-alt</v-icon>
                                            </v-avatar>

                                            <v-avatar class="btn_otro px-0 mx-0 mt-1 white--text" size="19">
                                                <v-icon class="white--text" size="11">fa-copy</v-icon>
                                            </v-avatar>
                                        </v-row>
                                    </template>


                                    <v-card>
                                        <v-row>

                                            <v-col class="py-0" cols="auto">
                                                <v-tooltip bottom color="#1b1b1b">
                                                    <template v-slot:activator="{ on }">
                                                        <v-col>
                                                            <v-row class="py-0">
                                                                <span style="font-size: 11px" class="font-weight-bold">EDITAR</span>
                                                            </v-row>

                                                            <v-row class="py-0">
                                                                <v-btn  v-if="componenteEvento.editar_submodulo" v-on="on" :disabled="item.id_estado == 3 || item.id_estado == 4" class="btn_editar mx-auto mb-1" fab x-small @click="editItem(item)">
                                                                    <v-icon>fa-pencil-alt</v-icon>
                                                                </v-btn>
                                                            </v-row>
                                                        </v-col>
                                                    </template>
                                                    <span class="text-uppercase">EDITAR {{$t('titulo.progDocente')}}</span>
                                                </v-tooltip>
                                            </v-col>


                                            <v-col class="py-0" cols="auto">
                                                <v-tooltip bottom color="#1b1b1b">
                                                    <template v-slot:activator="{ on }">
                                                        <v-col>
                                                            <v-row class="py-0">
                                                                <span style="font-size: 11px" class="font-weight-bold">BORRAR</span>
                                                            </v-row>

                                                            <v-row class="py-0">
                                                                <v-btn  v-if="componenteEvento.editar_submodulo" v-on="on" :disabled="item.id_estado != 1 || (new Date(item.fec_us_ing).toISOString().substr(0,10) != new Date().toISOString().substr(0,10))" class="mx-auto mb-1 btn_eliminar" fab x-small  @click="deleteConfirm(item)">
                                                                    <v-icon>fa-trash-alt</v-icon>
                                                                </v-btn>
                                                            </v-row>
                                                        </v-col>
                                                    </template>
                                                    <span class="text-uppercase">BORRAR {{$t('titulo.progDocente')}}</span>
                                                </v-tooltip>

                                            </v-col>


                                            <v-col class="py-0" cols="auto">
                                                <v-tooltip bottom color="#1b1b1b">
                                                    <template v-slot:activator="{ on }">
                                                        <v-col>
                                                            <v-row class="py-0">
                                                                <span style=" font-size: 11px" class="font-weight-bold">REPLICAR CLASE</span>
                                                            </v-row>

                                                            <v-row class="py-0">
                                                                <v-btn v-if="componenteEvento.agregar_submodulo" v-on="on"  class="btn_otro mx-auto mb-1" fab x-small  @click="replicarClase(item)">
                                                                    <v-icon>fa-copy</v-icon>
                                                                </v-btn>
                                                            </v-row>
                                                        </v-col>
                                                    </template>
                                                    <span class="text-uppercase">REPLICAR {{$t('titulo.progDocente')}}</span>
                                                </v-tooltip>

                                            </v-col>

                                        </v-row>
                                    </v-card>

                                </v-menu>

                            </td>


                            <td>
                                <v-tooltip bottom color="#1b1b1b">
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-if="componenteEvento.agregar_submodulo" v-on="on" :disabled="item.id_estado != 4" class="btn_asignar mx-2" fab x-small  @click="asignarActividades(item)">
                                            <v-icon>fa-book</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>ASIGNAR ACTIVIDAD</span>
                                </v-tooltip>
                            </td><!-- no permite asiganar actividad hasta que la clase se cambie a ejecutada -->



                            <td>
                                <v-tooltip bottom color="#1b1b1b">
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-if="componenteEvento.agregar_submodulo" v-on="on"  class="btn_editar mx-2" fab x-small  @click="asistenciaVirtual(item)">
                                            <v-icon>fa-users</v-icon>
                                        </v-btn>
                                    </template>
                                     <span>ASITENCIA DE CLASE VIRTUAL</span>
                                </v-tooltip>
                            </td>


                            <td>
                                <v-tooltip bottom color="#1b1b1b">
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-if="componenteEvento.visualizar_submodulo" v-on="on" class="mx-2 btn_imprimir" fab x-small  @click="verSeguimiento(item.id)">
                                            <v-icon>fa-clipboard-list</v-icon>
                                        </v-btn>
                                    </template>
                                    <span class="text-uppercase">SEGUIMIENTO DE {{$t('titulo.progDocente')}}</span>
                                </v-tooltip>
                            </td>

                        </tr>
                    </tbody>
                </template>
            </v-data-table>

            <!--
                <pre>programacion Docente: {{progDocente[0]}}</pre>
                <pre>Programar Clase: {{programarCl}}</pre>
            -->
        </v-card>
        <!--------   pantalla principal   ------>









        <!-- /////////////////////////////////////////////////////
        //         MODAL DE BORRAR REGISTROS                  //
        /////////////////////////////////////////////////////    -->
        <v-dialog v-model="dialog_delete" width="30%">
            <v-card>
                <v-card-title class="btn_ver">
                    <v-row class="d-flex justify-end py-0">
                        <v-btn fab dark x-small class="btn_style3" @click="dialog_delete=false"><v-icon dark>fa-times</v-icon></v-btn>
                    </v-row>
                </v-card-title>

                <v-card-text class="text-center">
                    <h3>¿Está seguro de borrar este registro
                        <v-chip color="yellow font-weight-black">{{desc_delete}}</v-chip>
                    ?</h3>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                        <v-btn class="btn_style3" dark  @click="dialog_delete=false">No</v-btn>
                        <v-btn class="btn_block_style2" dark  @click="deleteItem">Si</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- fin de modal de borrar registro -->





        <!-- ////////////////////////////////////////////////////
        //        MODAL DE SEGUIMIENTO O HISTORIAL        //
        ////////////////////////////////////////////////////    -->
        <v-dialog v-model="modal_seguimiento" persistent scrollable max-width="35%">
            <v-card>
                <v-card-title class="btn_otro">
                    <v-row class="d-flex justify-space-between py-0">
                        Seguimiento de la Clase
                        <v-btn fab dark x-small class="btn_style3" @click="modal_seguimiento=false"><v-icon dark>fa-times</v-icon></v-btn>
                    </v-row>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text>
                    <v-row>
                        <v-timeline>
                            <v-timeline-item v-for="(item, i) in seguimientoClase" :key="i" :color="item.color_estado" small >
                                <template v-slot:opposite>
                                    <span class="title font-weight-bold" >
                                        {{item.fec_us_ing}}
                                    </span>
                                </template>

                                <v-card class="elevation-2" width="350">
                                    <v-card-title class="headline">
                                        <v-chip dark class="font-weight-black" :color="item.color_estado">
                                            <h2>{{item.desc_estado}}</h2>
                                        </v-chip>
                                    </v-card-title>

                                    <v-card-text>
                                        <p class="body-1">
                                        <span class="black--text">Fecha:</span> {{item.fecha}}
                                        </p>

                                        <p class="body-1">
                                        <span class="black--text">Hora:</span> {{item.hora_inicio}} - {{item.hora_fin}}
                                        </p>

                                        <p class="body-1">
                                        <span class="black--text">Clase Virtual:</span> {{item.clase_virtual_desc}}
                                        </p>

                                        <p class="body-1">
                                        <span class="black--text">Observación:</span> {{item.observacion}}
                                        </p>

                                    </v-card-text>
                                </v-card>
                            </v-timeline-item>
                        </v-timeline>

                    </v-row>

                </v-card-text>

            </v-card>
        </v-dialog>
        <!-- fin modal de Seguimiento -->



    </div>
</template>


<script>
    import axios from "../../../helpers/axios"
    import {mapMutations, mapGetters, mapActions} from 'vuex'
    import ModalCalendario from './components/Calendario.vue'
    import ModalVisorCk1 from '../../VisorContenido/Visor.vue'
    import ModalVisorColegio from './components/listaDiapositivas.vue'
    import ModalAsignarActividades from './components/CalendarioActividades.vue'
    import ModalVerActividades from './components/ActividadesDocente.vue'
    import ModalAsistenciaVirtual from './components/AsistenciaVirtual.vue'
    import ModalSeleccionarClaseEc from './components/SeleccionarClaseEc.vue'
    //import ModalProgramarClase from './components/ProgramarClase.vue'


    export default {
        name: "programaciondocenteec",

        components:{
            ModalCalendario,
            ModalVisorCk1,
            ModalVisorColegio,
            ModalAsignarActividades,
            ModalVerActividades,
            ModalAsistenciaVirtual,
            ModalSeleccionarClaseEc,
            //ModalProgramarClase,
        },

        data: () => ({
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
            paramComponente:{ 'id_submodulo':82, "id_modulo": 7}, //sud_modulo y modulo

            datoLogin: sessionStorage, // variables de sesion del usuario
            ////////////////////////////////////////////////////////


            //validaciones de formulario
            rul: {
                required: value => !!value || 'Campo Requerido',
                inputReq: value => !!value || 'Campo Requerido',
                selectReq: value => !!value || 'Debe seleccionar un campo de la lista',
                email: value => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) || 'El correo Electrónico es incorrecto',
                min4: v => (v || '').length >= 4 || 'Mínimo 4 caracteres',
                min6: v => (v || '').length >= 6 || 'Mínimo 6 caracteres',
                min8: v => (v || '').length >= 8 || 'Mínimo 8 caracteres',
                max10: v => (v || '').length <= 10 || 'Máximo 10 caracteres',
                max11: v => (v || '').length <= 11 || 'Máximo 11 caracteres',
                max12: v => (v || '').length <= 12 || 'Máximo 12 caracteres',
                max20: v => (v || '').length <= 20 || 'Máximo 20 caracteres',
                max30: v => (v || '').length <= 30 || 'Máximo 30 caracteres',
                max40: v => (v || '').length <= 40 || 'Máximo 40 caracteres',
                max50: v => (v || '').length <= 50 || 'Máximo 50 caracteres',
                max60: v => (v || '').length <= 60 || 'Máximo 60 caracteres',
                max100: v => (v || '').length <= 100 || 'Máximo 100 caracteres',
                max150: v => (v || '').length <= 150 || 'Máximo 150 caracteres',

                email_null: value => {
                    if(value == '') {
                        return false
                    }
                    else{
                        const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/
                        return pattern.test(value) || 'El correo Electrónico es incorrecto'
                    }
                },


                hora: value => {
                    if(value < '01:00') {
                        return 'El formato de la hora ingresada es incorrecto'
                    }
                    else{
                        if(value >= '13:00') {
                            return 'El formato de la hora ingresada es incorrecto'
                        }
                    }
                },
            },



            // consulta principal

            // variable iniciales
            inhabilitarGradoDoc: true,
            inhabilitarAreaDoc: true,
            inhabilitarCursoDoc: true,

            filtroProgDoc :[],
            nivelDoc   :[],
            gradoDocFilter: [],
            areaDocFilter:[],
            cursoDocFilter: [],

            gradoDoc   :[],
            areaDoc    :[],
            cursoDoc   :[],

            showMenu: false,
            progDocente    :[],
            search: "",
            ///////////////////////////////////////////////////////////////////////


            // componente Seleccionar Clase
            componenteSelecClaseEC : '',
            estadoModalSelecClaseEC : false,
            parametroSelecClaseEC : [],
            estadoConsultaEC: false,
            ////////////////////////////////////



            // componente Programar Clase
            componenteProgClase : '',
            estadoModalProgClase : false,
            parametroProgClase : [],
            estadoConsultaProgClase: false,
            ////////////////////////////////////



            // modal confirmacion
            dialog_delete: false,
            desc_delete:null,
            id_delete:null,
            /////////////////////////



            // modal  de seguimiento
            modal_seguimiento : false,
            seguimientoClase: [],
            ////////////////////////////////


            // modal visor de contenidos
            visor: false,
            api_list_contenidos:[],
            tipoVisor: '',
            ///////////////////////////



            // componente actividades del docente
            tipoComponente: '',
            componenteAsistencia: '',
            modalActividad: '',
            estadoModal: true,



            // componente Asistencia Variables
            estadoModalAsistencia: true,
            parametroAsistencia:[],

            modalCrearActividad:'',

            datosClase: [],
            itemClaseSeccion: [],

            eventoActividad:'',
            valorEvento: '',
            ////////////////////////////



            // modal calendario
            componenteCalendario: '',
            estadoModalCalen: false,
            ////////////////////////////////////
        }),



        computed: {
            ...mapGetters('login', [ 'componenteEvento']),
        },


        mounted() {
            //this.listarTemas();
            this.loadMain()
        },


        created(){
             this.actualizarParamentro()
        },


        methods: {
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
            //  ------- MENSAJE DE SISTEMA  --------
            ...mapMutations('mensajeSis', ['setEnviarMens']),

            //----- Validar accesos por perfil ------------
            ...mapActions('login',['parametroComponente'] ),

            actualizarParamentro() {
                this.parametroComponente(this.paramComponente)
            },
            ////////////////////////////////////////////////////////


            //// modal calendario
            ...mapMutations('progDocente', ['setActivarCalendario']),



            //  ------- Cargar todos los registros principales al iniciar el componente   --------
            async loadMain(){
                try{
                    let params = `/periodo/${this.datoLogin.id_ano_lectivo}/colegio/${this.datoLogin.id_colegio}/usuario/${this.datoLogin.id}`
                    let response = await axios.get(`/academico/progDocente/getQuery${params}`)
                    let data = response.data
                    this.nivelDoc    = data.payload.NivelDoc
                    this.gradoDoc    = data.payload.GradoDoc
                    this.areaDoc     = data.payload.AreaDoc
                    this.cursoDoc    = data.payload.CursoDoc
                    this.seccionDoc  = data.payload.SeccionDoc
                    this.progDocente = data.payload.ProgDocente
                }

                catch(error){
                    this.setEnviarMens({tipo:"E", mensaje: `Error: ${error}`, tiempo:null})
                    //console.log(error)
                }
            },


            validarEnlace(enlaceVirtual, horaInicio, horaFin ){ //estado

                /////// FUNCION PARA TRAER FECHA ACTUAL
                function ckeckTime(i){
                    if(i<10){
                        i="0"+i
                    }
                    return i
                }

                let hora = new Date()
                let horaHora = ckeckTime(hora.getHours())
                let horaMin = ckeckTime(hora.getMinutes())
                let horaActual = `${horaHora}:${horaMin}:00`
                var mensaje = "";
                var error = 0

                if(horaActual < horaInicio){
                    mensaje += "La Clase no ha iniciado"
                    error    = 1

                }


                if(horaActual > horaFin){
                    mensaje += " La Clase ya culminó"
                    error    = 1

                }


                if(error == 0){
                    //this.setEnviarMens({tipo:"S", mensaje: `Activar Link`, tiempo:null})
                    window.open(enlaceVirtual)

                }else{
                    this.setEnviarMens({tipo:"E", mensaje: `Error: ${mensaje}`, tiempo:null})

                }
            },


            //  manejador del evento nivel de la programacion de clase
            eventNivelDoc(){
                this.inhabilitarGradoDoc = false
                this.inhabilitarAreaDoc  = true
                this.inhabilitarCursoDoc = true

                // filtro y cargo los valores del grado segun el nivel
                //let filtro = this.asociarCl.id_nivel

                this.gradoDocFilter = this.gradoDoc.filter(el=>el.id_nivel == this.filtroProgDoc.id_nivel)
            },


            // manejador del evento grado de la programacion de clase
            eventGradoDoc(){
                this.inhabilitarAreaDoc  = false
                this.inhabilitarCursoDoc = true

                this.areaDocFilter = this.areaDoc.filter(el=>el.id_grado == this.filtroProgDoc.id_grado)
                // carga la seccion segun el grado seleccionado
                this.seccionDocFilter = this.seccionDoc.filter(el=>el.id_grado == this.filtroProgDoc.id_grado)
            },



            // manejador del evento area de programacion de clase
            eventAreaDoc(){
                this.inhabilitarCursoDoc = false

                //this.cargarClases()
                // filtro y cargo los valores del los curso segun el grado
                let gradoDocFilter = this.cursoDoc.filter(el=>el.id_grado == this.filtroProgDoc.id_grado)
                this.cursoDocFilter = gradoDocFilter.filter(el=>el.id_area == this.filtroProgDoc.id_area)
            },





            // inicia la modal asociar clase
            asociarClaseEc(){
                if(this.filtroProgDoc.id_curso == '' || this.filtroProgDoc.id_curso == null ){
                    this.setEnviarMens({tipo:"W", mensaje: `Debe seleccionar un Nivel, Grado, Área y  ${this.$t('titulo.curso')}`, tiempo:null})
                }

                else{
                    this.componenteSelecClaseEC = 'ModalSeleccionarClaseEc'
                    this.estadoModalSelecClaseEC = true
                    this.parametroSelecClaseEC = {id_nivel: this.filtroProgDoc.id_nivel, id_grado: this.filtroProgDoc.id_grado,
                                               id_area: this.filtroProgDoc.id_area, id_curso: this.filtroProgDoc.id_curso,
                                               nivelDoc: this.nivelDoc, gradoDoc: this.gradoDoc,
                                               areaDoc: this.areaDoc, cursoDoc: this.cursoDoc}

                    this.estadoConsultaEC = false
                }
            },



            // Levanta la modal para programar la clase  (agregar)
            addItem(items, tipo_contenido){
                this.componenteProgClase = 'ModalProgramarClase'
                this.estadoModalProgClase = true
                this.parametroProgClase = {items, evento: 'agregar', nivelDoc: this.nivelDoc,
                                           gradoDoc: this.gradoDoc, areaDoc: this.areaDoc,
                                           cursoDoc: this.cursoDoc, seccionDoc: this.seccionDoc, tipo_contenido,
                                           id_nivel: this.filtroProgDoc.id_nivel, id_grado: this.filtroProgDoc.id_grado,
                                           id_area: this.filtroProgDoc.id_area, id_curso: this.filtroProgDoc.id_curso,}

                this.estadoConsultaProgClase = false

                this.estadoConsultaEC = false
            },



            // replicar la clase del docente ya programada
            replicarClase(items){
                this.componenteProgClase = 'ModalProgramarClase'
                this.estadoModalProgClase = true
                this.parametroProgClase = {items, evento: 'replicar', nivelDoc: this.nivelDoc,
                                           gradoDoc: this.gradoDoc, areaDoc: this.areaDoc,
                                           cursoDoc: this.cursoDoc, seccionDoc: this.seccionDoc}

                this.estadoConsultaProgClase = false
            },



            // Levanta la modal para programar la clase  (agregar)
            editItem(items){

                this.componenteProgClase = 'ModalProgramarClase'
                this.estadoModalProgClase = true
                this.parametroProgClase = {items, evento: 'editar', nivelDoc: this.nivelDoc,
                                           gradoDoc: this.gradoDoc, areaDoc: this.areaDoc,
                                           cursoDoc: this.cursoDoc, seccionDoc: this.seccionDoc}

                this.estadoConsultaProgClase = false
            },


            // recargar loadMain al programar clase
            cargarMain(){
                this.estadoConsultaEC = true //actualizar modal de seleccionar clases

                this.estadoModalProgClase = false
                this.loadMain()
            },



            async verSeguimiento(id){
                this.modal_seguimiento = true

                let response = await axios.get("/academico/progDocente/getSeguimiento/"+id)
                this.seguimientoClase = response.data.payload.Seguimiento
            },



           // componente de  calendario
            verCalendario(){
                this.componenteCalendario = 'ModalCalendario'
                this.estadoModalCalen = true
            },


            // activa la modal para confirmar el borrar el registro
            deleteConfirm(items){
                this.dialog_delete = true
                this.id_delete   =  items.id
                this.desc_delete = `Tema: ${items.nombre_tema}, fecha:${items.fecha},Hora ${items.hora_inicio} - (${items.id})`
            },



            //------------BORRAR Registro -------------
            async deleteItem() {
                this.dialog_delete = false
                try{
                    let resp = await axios.delete("/academico/progDocente/"+this.id_delete)
                    this.loadMain()
                    this.dialog = false
                    this.setEnviarMens({tipo:resp.data.messageT, mensaje: resp.data.message, tiempo:null})
                }

                catch(error){
                    this.setEnviarMens({tipo:"E", mensaje: `${error}`, tiempo:null})
                }
            },



            // botos para visualizar clases de la programacion de contenido
            async visualizarClase(id_clase, tipo_contenido){
                try{
                    if(tipo_contenido == 1){
                        let response = await axios.get("/manager/contenido/list/"+id_clase+"");
                        this.api_list_contenidos = response.data;

                        this.tipoVisor = 'ModalVisorCk1'
                        this.visor = true
                    }

                    else{
                        let response = await axios.get("/administrativo/contenido/list/"+id_clase+"");

                        //let response = await axios.get("/administrativo/contenido/"+id_clase+"");
                        this.api_list_contenidos = response.data;

                        this.tipoVisor = 'ModalVisorColegio'
                        this.visor = true
                    }
                }

                catch(error){
                    this.setEnviarMens({tipo:"E", mensaje: `Error: ${error}`, tiempo:null})
                    //console.log(error)
                }
            },


            // funcion para cerrar modal
            cerrarVisor(){
               this.visor = false;
               this.api_list_contenidos = []
               this.tipoVisor = ''
            },



            // botos para visualizar calendario de actividades por seccion para crear la actividad
            async asignarActividades(item){
                this.tipoComponente = 'ModalAsignarActividades'
                this.estadoModal = true
                this.itemClaseSeccion = item

                this.valorEvento = 'agregar'
                //this.modalActividad = true
            },



            //mddal ver actividades del docente
            verActividades(){
                this.tipoComponente = 'ModalVerActividades'
                this.estadoModal    = true
            },


            // function para visualizar la clase virtual de la programacion docente
            async asistenciaVirtual(item){
                this.componenteAsistencia = 'ModalAsistenciaVirtual'
                this.estadoModalAsistencia = true
                this.parametroAsistencia = item
            },


        }
    };
</script>